// JavaScript Document
//components/view/View.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
	Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
	Paper, Checkbox, Snackbar, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import operators from './Operators';
import ViewBar from './Toolbar';



const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow:1,
	},
  	table: {
    	minWidth: 650,
		maxHeight:'calc(100vh - 64px)',
		//maxHeight: '100%'
	},
}));

export default function Signs(props) {
	//display classes
	const classes = useStyles();
	//Inherited props
  	const {handleSend, user, organization, defaultView, fields, items, RowTemplate, label} = props;
	//control loading from server
  	const [loaded, setLoaded] = React.useState(false);
	//available views 
  	const [views, setViews] = React.useState([defaultView]);
	//current view
  	const [view, setView] = React.useState(defaultView);
	//search keyword filter
  	const [search, setSearch] = React.useState('');
	//selected rows
	const [selected, setSelected] = React.useState(new Set());
	//Enable websocket for bulk actions
	const [enableWebsocket, setEnableWebsocket] = React.useState(false);
	//Initiate bulk actions
	const [bulkActions, setBulkActions] = React.useState([]);
	//Toaster
	const [toast, setToast] = React.useState({
		open: false,
		message: '',
		severity: 'info'
	});
	//Confirmation state for confirm message
	const [confirmState, setConfirmState] = React.useState({
		open: false,
		message: '',
		action: null,
		items: []
	});
	//All filter operators
  	const allOps = operators();
	/*
	//conditions for current view
  	const filter = view.lv_filter.conditions.map(n => {
		//get the relevant operator
		let operator = allOps.find(o => o.id === n.operator);
		//field for which operator applies
		let out = {
			field : n.field
		};
		//compile the test condition
		//if operator test does not include a comparison
		if(operator.notcompare) {
			out.test = operator.test;
		} else {
			//operator test includes a comparison, set the static variable it is compared with
			out.test = (cv) => {return operator.test(n.value, cv)};
		}
		//returns field & test
		return out;
  	});
	*/
	//Can we select rows?
	const selectRows = (bulkActions && bulkActions?.length > 0);
	//Is the socket ready?
	const isSockReady = () => readyState === ReadyState.OPEN;
	//show toast handler
	const showToast = (message, severity = 'info') => {
		setToast({
			open: true,
			message,
			severity
		});
	}

	//PERFORMANCE UPGRADE: conditions for current view
  	const filter = React.useMemo(() => {
		return view.lv_filter.conditions.map(n => {
			//get the relevant operator
			let operator = allOps.find(o => o.id === n.operator);
			//field for which operator applies
			let out = {
				field : n.field
			};
			//compile the test condition
			//if operator test does not include a comparison
			if(operator.notcompare) {
				out.test = operator.test;
			} else {
				//operator test includes a comparison, set the static variable it is compared with
				out.test = (cv) => {return operator.test(n.value, cv)};
			}
			//returns field & test
			return out;
  		});
	}, [view, allOps]);

	
	//on state change
  	React.useEffect(() => {
		//if signs have not been loaded from UI yet
		if(!loaded){
			//getSignsList();
			getViewsList();
		}
	});
	//get available views from server
  	const getViewsList = () => {
        setLoaded(true);
		handleSend({
			vso: 'views',
			table : defaultView.lv_table,
		}, (data) => {
			if(data.views){
				//parse json strings
				let viewlist = data.views.map(v => {
					if(typeof v.lv_fields === 'string') v.lv_fields = JSON.parse(v.lv_fields);
					if(typeof v.lv_filter === 'string') v.lv_filter = JSON.parse(v.lv_filter);
					if(typeof v.lv_sort === 'string') v.lv_sort = JSON.parse(v.lv_sort);
					return v;
				});
				//add default view at front
				viewlist.unshift(defaultView);
				//check if user has their own default
				let userdefault = viewlist.find(n => n.is_default);
				setViews(viewlist);
				if(userdefault){
					console.log('user default view', userdefault);
					setView(userdefault);
				}
			}
			if(data.bulkops && data.bulkops?.length > 0){
				//there are bulk actions available for this view
				let bulkops = data.bulkops.map(b => {
					if(typeof b.ax_args === 'string') b.ax_args = JSON.parse(b.ax_args);
					if(typeof b.af_values === 'string') b.af_values = JSON.parse(b.af_values);
					return b;
				});
				setBulkActions(bulkops);
				//Enable websocket, if applicable
				if(data.bulkops.some(n => n.ax_target === 'websocket')) setEnableWebsocket(true);
				//connect to websocket here if data.bulkops.find(n => n.ax_target === 'websocket')
			}
		})
  	}
	//for websocket actions, load websocket
	const { sendJsonMessage, readyState} = useWebSocket(
		process.env.REACT_APP_WEBSOCKET_URL, 
		{
			onOpen : () => {
				console.log('WebSocket connection established.');
				
			},
			shouldReconnect: (closeEvent) => true,
			share: true,
		},
		enableWebsocket
	);
	
	

	//compile fields used in this view
	var usedFields = fields(view.lv_fields);

	//text fields
	var txtfields = usedFields.filter(n => n.type === 'VARCHAR');

  	//When value of view dropdown is changed
  	const handleChangeView = (newView) => {
		setView(views.find(n => n.id === newView));
  	}

  	//When the search filter is updated
  	const handleSearch = (value) => {
		setSearch(value);
  	}
	/*
	//apply view and search to signs list
  	const filteredList = () => {
		//sort signs using view sorting
		items.sort(applySort);
		//if no filters applied, use the signs list
		if(filter.length === 0 && !search) return items;
		//apply search and view filters
		return items.filter(applySearch).filter(applyFilter);
  	}
		*/

	//Improve performance - memorize filtered list
	const filteredList = React.useMemo(() => {
		//apply search query to each row
		const applySearch = (row, i) => {
			if(!search) return true;
			//search all textfields for search query
			return txtfields.findIndex(
				n => row[n.name] 
				&& row[n.name].toLowerCase().includes(search.toLowerCase())
			) !== -1;	
		}
		//apply view filter to each row
		const applyFilter = (row, i) => {
			//always true if no conditions exist
			if(filter.length === 0) return true;
			//run each test
			let res = filter.map(n => n.test(row[n.field]));
			//for custom filters
			if(view.lv_filter.type === 'CUSTOM'){
				//start computed at 1
				res.unshift(true);
				//convert to object
				let map = Object.assign({}, res);
				//add AND OR
				Object.assign(map, {'AND': '&&', 'OR':'||'});
				//compile test string TODO: test with double-digit conditions
				let testString = view.lv_filter.custom.replace(/[0-9]|AND|OR/g, n => map[n]);
				//run test string
				// eslint-disable-next-line no-eval
				return eval(testString);
			}
			//number of tests passed
			let fin = res.reduce((acm, n) => acm + (n ? 1 : 0), 0);
			//and requires all, or requires any
			return (view.lv_filter.type === 'AND' && fin === res.length) || (view.lv_filter.type === 'OR' && fin > 0);
		}
		//apply view sorting rules (each row)
		const applySort = (a, b) => {
			if(view.lv_sort.length === 0) return 0;
			//iterate each sort rule until a match is found
			for(let sort of view.lv_sort){
				if(a[sort.name] < b[sort.name]) return sort.type === 'ASC' ? -1 : 1;
				if(a[sort.name] > b[sort.name]) return sort.type === 'ASC' ? 1 : -1;
			}
			//all rules produce === results, records are the same
			return 0;
		}
		//sort signs using view sorting
		const sorted = [...items].sort(applySort);
		//if no filters applied, use the signs list
		if(filter.length === 0 && !search) return sorted;
		//apply search and view filters
		return sorted.filter(applySearch).filter(applyFilter);
		//eslint-disable-next-line
	}, [items, search, view, filter]);

	

	

	

	//toggle single row
	const handleSelectRow = (row) => {
		const exists = selected.has(row.id);
		const next = new Set(selected);
		if(exists){
			next.delete(row.id);
			//setSelected(selected.filter(id => id !== row.id));
		} else {
			next.add(row.id);
			//setSelected(new Set([...selected, row.id]));
		}
		setSelected(next);
	}

	//select all visible rows
	const handleSelectAll = () => {
		const ids = new Set(filteredList.map(row => row.id));
		setSelected(ids);
	}

	//deselect all
	const handleDeselectAll = () => {
		setSelected(new Set());
	}

	//is row selected
	const isSelected = (row) => {
		return selected.has(row.id);
	}

    const compileRow = (row, i) => {
		const checked = isSelected(row);
		const rowContent = (
			<>
				{selectRows && (
					<TableCell
						padding="checkbox"
						onClick={(e) => e.stopPropagation()}
					>
						<Checkbox
							checked={checked}
							onChange={() => handleSelectRow(row)}
						/>
					</TableCell>
				)}

				{usedFields.map((field, i) => (
					React.cloneElement(
						field.render(row, i),
						{
							key: field.name || i
						}
					)
				))}
			</>
		);
		if(RowTemplate){
			return (
				<RowTemplate
					key={row.id || i}
					row={row}
					selected={checked}
				>
					{rowContent}
				</RowTemplate>
			);
		}
		return (
			<TableRow
				hover
				key={row.id || i}
				selected={checked}
			>
				{rowContent}
			</TableRow>
		);
	}
	//compile arg values from action
	const compileArgList = (action) => action.ax_args.reduce((a, c, i) => ({...a, [c.name] : action.af_values[i]}), {});
	//Execute selected bulk action
	const executeBulkAction = (action, compatItems) => {

		if(action.ax_target === 'websocket'){

			if(isSockReady()){

				compatItems.forEach(n => sendJsonMessage({
					...n,
					action : action.ax_endpoint,
					user_id : user.id,
					...compileArgList(action)
				}));

				showToast(
					`Queued ${action.af_label} for ${compatItems.length} compatible ${label}`,
					'success'
				);

			} else {

				showToast(
					'WebSocket not connected',
					'error'
				);
			}

		} else {

			showToast(
				'API endpoint not supported',
				'warning'
			);
		}
	}

	//Bulk Action handler (with selected)
	const handleBulkAction = (actionId) => {
		//find action by ID
		let action = bulkActions.find(n => n.id === actionId)
		if(!action) {
			console.log('Action not found', actionId);
			showToast(
				'Action not found',
				'error'
			);
			return;
		}
		//console.log('Action Found', action);
		//confirm selected signs are compatible
		let compatItems = items.filter(n => {
			//TODO add filter for selected
			if(!selected.has(n.id)) return false;
			if(action.class_code && n.class_code !== action.class_code) return false;
			if(action.ax_remote_only && !n.ip) return false;
			if(action.ax_option && !n.options?.includes([',', action.ax_option, ','].join(''))) return false;
			return true;
		});
		if(compatItems.length === 0){
			//display no compatible items toast message
			showToast(
				'No compatible ' + label + ' found',
				'warning'
			);
			return;
		}

		//confirmation required
		if(action.af_confirm){

			setConfirmState({
				open: true,
				message: action.af_confirm.replaceAll(
					'{n}',
					compatItems.length
				),
				action,
				items: compatItems
			});

			return;
		}

		//no confirmation needed
		executeBulkAction(
			action,
			compatItems
		);
		
	}

      


	//compile result
	return (
		<div>
			<ViewBar 
				views={views} 
				selected={view.id} 
				search={search} 
				user={user} 
				organization={organization} 
				onChange={handleChangeView} 
				onSearch={handleSearch} 
				onUpdate={setViews} handleSend={handleSend}
                fields={fields}
                operators={operators}
				label={label}
				selectedRows={selected}
				bulkActions={bulkActions}
				onBulkAction={handleBulkAction}
			/>
    		<TableContainer component={Paper} className={classes.table}>
      			<Table stickyHeader aria-label="signs list">
        			<TableHead>
          				<TableRow>
							{selectRows && (
							<TableCell padding="checkbox" key="cbhead">
								<Checkbox
									indeterminate={
										selected.size > 0 &&
										selected.size < filteredList.length
									}
									checked={
										filteredList.length > 0 &&
										selected.size === filteredList.length
									}
									onChange={(e) => {
										if(e.target.checked){
											handleSelectAll();
										} else {
											handleDeselectAll();
										}
									}}
								/>
							</TableCell>)}
            				{usedFields.map((field, i) => (
								<TableCell key={i}>{field.label}</TableCell>
							))}
          				</TableRow>
        			</TableHead>
        			<TableBody>
          				{filteredList.map(compileRow)}
        			</TableBody>
      			</Table>
    		</TableContainer>
			<Snackbar
				open={toast.open}
				autoHideDuration={4000}
				onClose={() => {
					setToast({
						...toast,
						open: false
					});
				}}
			>
				<MuiAlert
					elevation={6}
					variant="filled"
					severity={toast.severity}
				>
					{toast.message}
				</MuiAlert>
			</Snackbar>
			<Dialog
				open={confirmState.open}
				onClose={() => {
					setConfirmState({
						...confirmState,
						open: false
					});
				}}
			>

				<DialogTitle>
					Confirm Action
				</DialogTitle>

				<DialogContent>

					<DialogContentText>
						{confirmState.message}
					</DialogContentText>

				</DialogContent>

				<DialogActions>

					<Button
						onClick={() => {
							setConfirmState({
								...confirmState,
								open: false
							});
						}}
					>
						Cancel
					</Button>

					<Button
						color="secondary"
						variant="contained"
						onClick={() => {

							executeBulkAction(
								confirmState.action,
								confirmState.items
							);

							setConfirmState({
								...confirmState,
								open: false
							});
						}}
					>
						Confirm
					</Button>

				</DialogActions>

			</Dialog>			
		</div>
	);
}
